import Scene from '../classes/scene';
const scene = (state = new Scene({}), action) => {
    switch (action.type) {
        case 'INITIALIZE_SCENE':
            return action.scene;
        case 'SET_TRAIL_LENGTH': {
            const settings = Object.assign(Object.assign({}, state.sceneSettings), { trailLength: action.trailLength });
            return Object.assign(Object.assign({}, state), { sceneSettings: settings });
        }
        default:
            return state;
    }
};
export default scene;
